// Order/OrderStatus.tsx
import React from 'react';
import {IOrder} from "../../Types/commerce/shop";
import {FR} from "WideLayout/Layouts";
import StatusItem from './OrderStatusItem';
import {useTheme} from "Theme/ThemeContext";

interface OrderStatusProps {
    order: IOrder;
}

const OrderStatus: React.FC<OrderStatusProps> = ({order}) => {
    const {plt} = useTheme();

    const statusList = [
        {
            label: 'Оплачен',
            isActive: order.is_paid,
            color: order.is_paid ? plt.colors.secondary.main : plt.colors.error.main,
            showNegative: true, // Показывать "Не оплачен"
        },
        {
            label: 'Инициализирован',
            isActive: order.is_inited,
            color: order.is_inited ? plt.colors.secondary.main : plt.colors.error.main,
            showNegative: true, // Показывать "Не инициализирован"
        },
        {
            label: 'Выполнен',
            isActive: order.is_executed,
            color: order.is_executed ? plt.colors.secondary.main : plt.colors.error.main,
            showNegative: true, // Показывать "Не выполнен"
        },
        {
            label: 'Отменён',
            isActive: order.is_cancelled,
            color: order.is_cancelled ? plt.colors.error.main : plt.colors.secondary.main,
            showNegative: false, // Не показывать "Не отменён"
        },
        {
            label: 'Возвращен',
            isActive: order.is_refunded,
            color: order.is_refunded ? plt.colors.error.main : plt.colors.success.main,
            showNegative: false, // Не показывать "Не возвращен"
        },
    ];

    return (
        <FR g={'.5rem'} wrap>
            {statusList.map((status, index) => (
                <StatusItem
                    key={index}
                    label={status.label}
                    isActive={status.isActive}
                    color={status.color}
                    showNegative={status.showNegative}
                />
            ))}
        </FR>
    );
};

export default OrderStatus;
